import React, { createContext, useEffect, useMemo, useState } from 'react';
import { node } from 'prop-types';

import { genericStorage } from '@ajaibid/utils';
import { GENERIC_STORAGE_KEY } from '@config/constanta';

const DEFAULT_STATE = [
  {
    code: 'BBRI',
  },
  {
    code: 'BBCA',
  },
  {
    code: 'TLKM',
  },
  {
    code: 'ANTM',
  },
];

export const StockTickerTabContext = createContext({ ticks: DEFAULT_STATE });

function StockTickerTabProvider({ children }) {
  const [ticks, setTicks] = useState(DEFAULT_STATE);
  const [isReady, setIsReady] = useState(false);

  // Load from genericStorage
  useEffect(() => {
    const load = () => {
      const textData = genericStorage.get(GENERIC_STORAGE_KEY.tickerTabs);

      try {
        const data = textData ? JSON.parse(textData) : DEFAULT_STATE;
        setTicks(data);
      } catch (err) {
        console.error('Fail load tickerTabs data from localStorage');
      }
      setIsReady(true);
    };

    if (isReady) {
      return;
    }

    load();
  }, [isReady, setIsReady]);

  // Save data to genericStorage
  useEffect(() => {
    if (!isReady) {
      return;
    }
    const strippedTicks = ticks.map(({ code }) => ({ code }));

    const textData = JSON.stringify(strippedTicks);
    genericStorage.set(GENERIC_STORAGE_KEY.tickerTabs, textData);
  }, [ticks, isReady]);

  const contextValue = useMemo(() => ({ ticks, setTicks, isReady }), [ticks, setTicks, isReady]);

  return (
    <StockTickerTabContext.Provider value={contextValue}>{children}</StockTickerTabContext.Provider>
  );
}

StockTickerTabProvider.defaultProps = {
  children: null,
};
StockTickerTabProvider.propTypes = {
  children: node,
};

export default StockTickerTabProvider;
